"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
// checks if password has 8 symbols, 1 upper, 1 lower letter and 1 special character
exports.isPasswordStrong = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[\w!"#$%&'()*+,-./:;<=>?@[\]^`{|}~]{8,}$/);
function equalTo(reference, message) {
    return yup.mixed().test({
        name: "equalTo",
        exclusive: false,
        message,
        params: {
            reference: reference.path,
        },
        test(value) {
            return value === this.resolve(reference);
        },
    });
}
exports.equalTo = equalTo;
yup.addMethod(yup.string, "equalTo", equalTo);
exports.passwordConfirmation = (requiredMessage, mismatchMessage) => {
    return yup
        .string()
        .ensure()
        .equalTo(yup.ref("password"), mismatchMessage)
        .required(requiredMessage);
};
//# sourceMappingURL=validation.js.map